export const INPUT_TYPES = {
  TEL: "tel",
  TEXT: "text",
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
} as const;

export const INPUT_MODES = {
  NONE: "none",
  TEXT: "text",
  DECIMAL: "decimal",
  NUMERIC: "numeric",
  TEL: "tel",
  SEARCH: "search",
  EMAIL: "email",
  URL: "url",
} as const;
